import React from 'react';
import images from '../../assets/images';
import styles from '../../assets/css/cards/card-item.module.css';
import PropTypes from 'prop-types';

const CardItem = ({ children, ico, onClick }) => {
    const ICO = {
        upload: images.icoUpload,
        trash: images.icoTrash
    };
    return (
        <div
            role="button"
            onClick={onClick}
            tabIndex={0}
            onKeyDown={() => {}}
            className={styles.item__container}>
            <img src={ICO[ico] || ''} alt="" />
            <span>{children}</span>
        </div>
    );
};
CardItem.propTypes = {
    children: PropTypes.node.isRequired,
    ico: PropTypes.string,
    onClick: PropTypes.func
};

export default CardItem;
